import BaseApiService from "./base-services/baseApi.service";

class HeaderApiService extends BaseApiService {
    constructor() {
        super();
    }

    getSearchTest = async (data) => {
        const url = `/website/global-search`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getOpenSearchTest = async (data) => {
        const url = `/product/item/search`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getCityList = async () => {
        const url = `/website/locate/city/list`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    getNavigation = async () => {
        const url = `/website/menu/fetch`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    getOtp = async (data) => {
        // const url = `/auth/generate-otp`;
        const url = `/auth/login/generate-otp`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getOtpForUploadPrecsription = async (data) => {
        const url = `/auth/login/generate-otp`;
        const res = await this.axiosInstance.post(url, data);
        return res;
    };

    validateOtp = async (data) => {
        const url = `/auth/login/validate-otp`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    sendOtp = async (data) => {
        // const url = `/auth/login`;
        const url = `/auth/login/validate-otp`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    uploadPrecription = async (data) => {
        const url = `/ticket/upload-prescription`;
        const res = await this.axiosInstance.post(url, data);
        return res;
    };

    placeCallBackRequest = async (data) => {
        const url = `/ticket/place-callback-request`;
        const res = await this.axiosInstance.post(url, data);
        return res;
    };

    logout = async () => {
        const url = `/auth/logout`;
        const res = await this.axiosInstance.post(url);
        return await res.data;
    };

    updateSession = async (data) => {
        const url = `/auth/update-session`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getHookCentreDetails = async (hookCityId) => {
        const url = `/auth/hook-centre-details?hookCityId=${hookCityId}`;
        const res = await this.axiosInstance.get(url);
        return await res.data.data;
    };

    signUp = async (data) => {
        const url = `/auth/user/signup`;
        const res = await this.axiosInstance.post(url, data);
        return await res.data;
    };

    getSessionDetails = async () => {
        const url = `/auth/get-session-details`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };
}
const headerApiService = new HeaderApiService();
export { headerApiService };
